export default __webpack_public_path__ + "static/media/group.e7e2ba1d.svg";